import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledCrmEnrichmentContainer = styled(FlexColumn)``;

export const StyledCrmEnrichmentTitle = styled.div`
    display: flex;
    margin-top: 32px;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
`;

export const StyledCrmEnrichmentContent = styled(FlexRow)`
    margin-top: 24px;
    gap: 20px;
`;
